import * as angular from 'angular';
import { downgradeInjectable } from '@angular/upgrade/static';

import { ExperiencesService } from './experiences.service';

export const Ng1ExperiencesModule = angular
  .module('control-room.shared.services.experiences', [])
  .factory('crExperiencesService', downgradeInjectable(ExperiencesService));